// Builds a DTM API v3 displacement configuration URL for a given selection.
//
// The endpoint and primary pcode parameter follow the drill-down level:
//   - admin1 endpoint (Admin0Pcode) for a country-level selection
//   - admin2 endpoint (Admin1Pcode) once an admin 1 is selected
// The selected year is expressed as a full-calendar-year reporting-date range,
// since the API takes a date range rather than a Year parameter. Operation and
// cause are appended only when they are real selections (not "All").
export function buildDtmApiUrl({
  countryPcode,
  admin1Pcode,
  year,
  operation,
  cause,
} = {}) {
  const isAdmin2Level = Boolean(admin1Pcode);
  const endpoint = isAdmin2Level ? "admin2" : "admin1";
  const params = new URLSearchParams();

  if (isAdmin2Level) {
    params.append("Admin1Pcode", admin1Pcode);
  } else if (countryPcode) {
    params.append("Admin0Pcode", countryPcode);
  }

  if (year) {
    params.append("FromReportingDate", `${year}-01-01`);
    params.append("ToReportingDate", `${year}-12-31`);
  }
  if (operation && operation !== "All") {
    params.append("Operation", operation);
  }
  if (cause && cause !== "All") {
    params.append("CauseOfDisplacement", cause);
  }

  const query = params.toString();
  return `https://dtmapi.iom.int/v3/displacement/${endpoint}${
    query ? `?${query}` : ""
  }`;
}
